import React from 'react';
import { Input, Select, Checkbox } from 'formsy-react-components';
import { stateOptions } from '../../utils';

export const BillingJobInfo = React.createClass({
  getInitialState() {
    return {
      matchesProfile: false
    };
  },
  handleClick() {
    this.setState({
      matchesProfile: !this.state.matchesProfile
    });
  },

  render() {
    const { job, profile } = this.props;
    const { matchesProfile } = this.state;

    return (
      <div>
        <div className="form-panel">
          <div className="heading">Billing Info</div>
          <hr />
          <Checkbox
            name="checkbox1"
            value={matchesProfile}
            label="Same as profile info"
            onClick={this.handleClick}
          />
          <Input
            label={matchesProfile ? 'Name' : 'Carrier'}
            type="text"
            name="billing_name"
            value={
              matchesProfile
                ? profile.get('name')
                : job.get('billing_name') || ''
            }
            placeholder="Name"
            labelClassName="small-12"
            elementWrapperClassName="small-12"
            disabled={matchesProfile}
            required
          />
          <Input
            label={matchesProfile ? 'Street 1' : 'Carrier Street 1'}
            type="text"
            name="billing_street_1"
            value={
              matchesProfile
                ? profile.get('street_1')
                : job.get('billing_street_1') || ''
            }
            placeholder="Street 1"
            labelClassName="small-12"
            elementWrapperClassName="small-12"
            disabled={matchesProfile}
            required
          />
          <Input
            label={matchesProfile ? 'Apt/Suite #' : 'Carrier Apt/Suite #'}
            type="text"
            name="billing_street_2"
            value={
              matchesProfile
                ? profile.get('street_2')
                : job.get('billing_street_2') || ''
            }
            placeholder="Street 2"
            labelClassName="small-12"
            elementWrapperClassName="small-12"
            disabled={matchesProfile}
          />
          <Input
            label={matchesProfile ? 'City' : 'Carrier City'}
            type="text"
            name="billing_city"
            value={
              matchesProfile
                ? profile.get('city')
                : job.get('billing_city') || ''
            }
            placeholder="City"
            labelClassName="small-12"
            elementWrapperClassName="small-12"
            disabled={matchesProfile}
            required
          />
          <Select
            label={matchesProfile ? 'State' : 'Carrier State'}
            name="billing_state"
            options={stateOptions}
            value={
              matchesProfile
                ? profile.get('state')
                : job.get('billing_state') || ''
            }
            labelClassName="small-12"
            elementWrapperClassName="small-12"
            disabled={matchesProfile}
            required
          />
          <Input
            label={matchesProfile ? 'Zipcode' : 'Carrier Zipcode'}
            type="text"
            name="billing_zipcode"
            value={
              matchesProfile
                ? profile.get('zipcode')
                : job.get('billing_zipcode') || ''
            }
            placeholder="Zipcode"
            labelClassName="small-12"
            elementWrapperClassName="small-12"
            disabled={matchesProfile}
            required
          />
          <Input
            label="Name of Adjuster"
            type="text"
            name="billing_adjuster_name"
            value={
              matchesProfile
                ? profile.get('name')
                : job.get('billing_adjuster_name') || ''
            }
            placeholder="Adjuster Name"
            labelClassName="small-12"
            elementWrapperClassName="small-12"
            disabled={matchesProfile}
            required
          />
          <Input
            label="Adjuster Phone"
            type="text"
            name="billing_adjuster_phone"
            value={
              matchesProfile
                ? profile.get('phone')
                : job.get('billing_adjuster_phone') || ''
            }
            placeholder="Adjuster Phone"
            labelClassName="small-12"
            elementWrapperClassName="small-12"
            disabled={matchesProfile}
            required
          />
          <Input
            label="Adjuster Fax"
            type="text"
            name="billing_adjuster_fax"
            value={job.get('billing_adjuster_fax') || ''}
            placeholder="Adjuster Fax"
            labelClassName="small-12"
            elementWrapperClassName="small-12"
          />
          <Input
            label="Adjuster Email"
            type="email"
            name="billing_adjuster_email"
            value={
              matchesProfile
                ? profile.get('email')
                : job.get('billing_adjuster_email') || ''
            }
            validations="isEmail"
            placeholder="email@email.com"
            labelClassName="small-12"
            elementWrapperClassName="small-12"
            disabled={matchesProfile}
          />
        </div>
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./src/components/jobs/billing-job-info.jsx
 **/